import { render, staticRenderFns } from "./ConfigurazioniPage.vue?vue&type=template&id=46662826"
import script from "./ConfigurazioniPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports